import { useBusinessAbilities } from "@/modules/abilities";
import { routePaths } from "@/router/route-paths";

export const useBaseRoute = (): string => {
  const { canManageProcedures, canManageEnergySavingCertificates } =
    useBusinessAbilities();

  // ESC is the landing surface only for an agency that has nothing else
  // (P-2863). When both worlds are enabled, procedures are the everyday work
  // and the certificate list is one menu click away.
  if (canManageEnergySavingCertificates && !canManageProcedures) {
    return routePaths.energySavingCertificates;
  }

  return routePaths.procedureViewsIndex;
};
